var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedInLogoIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8_580)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.98 -0.00195312H5.98001C3.21901 -0.00195312 0.980011 2.23705 0.980011 4.99805V18.998C0.980011 21.759 3.21901 23.998 5.98001 23.998H19.98C22.742 23.998 24.98 21.759 24.98 18.998V4.99805C24.98 2.23705 22.742 -0.00195312 19.98 -0.00195312ZM8.98001 18.998H5.98001V7.99805H8.98001V18.998ZM7.48001 6.73005C6.51401 6.73005 5.73001 5.94005 5.73001 4.96605C5.73001 3.99205 6.51401 3.20205 7.48001 3.20205C8.44601 3.20205 9.23001 3.99205 9.23001 4.96605C9.23001 5.94005 8.44701 6.73005 7.48001 6.73005ZM20.98 18.998H17.98V13.394C17.98 10.026 13.98 10.281 13.98 13.394V18.998H10.98V7.99805H13.98V9.76305C15.376 7.17705 20.98 6.98605 20.98 12.239V18.998Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8_580"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.980011 -0.00195312)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedInLogoIcon);
export default __webpack_public_path__ + "static/media/linkedIn-logo-icon.3d776bf25fa0b1ed901e41c0927ec9eb.svg";
export { ForwardRef as ReactComponent };